import React, { useState, useEffect } from 'react';
import { Switch } from 'antd';
import FormTextField from '../general/FormTextField';

const DayTimePicker = ({
  daysData = [],
  categoryId,
  onChange,
  initialValues = [],
}) => {
  const [categoryDays, setCategoryDays] = useState([]);

  useEffect(() => {
    if (daysData?.length) {
      const merged = daysData.map((day) => {
        const existing = initialValues.find(
          (val) => val.DayId === day.SetupDetailId
        );

        return (
          existing || {
            CategoryId: categoryId || null,
            DayId: day.SetupDetailId,
            StartTime: "",
            EndTime: "",
            IsActive: false,
          }
        );
      });

      setCategoryDays(merged);
    }
  }, [daysData, categoryId, initialValues]);

  const updateDay = (dayId, field, value) => {
    const updated = categoryDays.map((day) =>
      day.DayId === dayId ? { ...day, [field]: value } : day
    );
    setCategoryDays(updated);
    onChange?.(updated);
  };

  const toggleDay = (dayId, checked) => {
    const updated = categoryDays.map((day) =>
      day.DayId === dayId ? { ...day, IsActive: checked } : day
    );
    setCategoryDays(updated);
    onChange?.(updated);
  };

  return (
    <div className="pt-3">
      <span className="mb-2">
        This category will be available 24/7 unless you specify custom hours.
      </span>
      <div className="day-time-picker bg-gray-50 border mt-1 p-4 rounded-lg">
        {daysData.map((day) => {
          const current = categoryDays.find(
            (item) => item.DayId === day.SetupDetailId
          );
          if (!current) return null;

          return (
            <div key={day.SetupDetailId} className="flex items-end gap-4 mb-2">
              <div className="w-28 font-semibold">{day.SetupDetailName}</div>

              <Switch
                checked={current.IsActive}
                onChange={(checked) => toggleDay(day.SetupDetailId, checked)}
                className="mr-2 bg-black"
              />

              <FormTextField
                type="time"
                style={{ width: "200px" }}
                placeholder="Start Time"
                label="Start Time"
                disabled={!current.IsActive}
                value={current.IsActive ? current.StartTime : ""}
                onChange={(e) =>
                  updateDay(day.SetupDetailId, "StartTime", e?.value)
                }
              />

              <FormTextField
                type="time"
                style={{ width: "200px" }}
                placeholder="End Time"
                label="End Time"
                disabled={!current.IsActive}
                value={current.IsActive ? current.EndTime : ""}
                onChange={(e) =>
                  updateDay(day.SetupDetailId, "EndTime", e?.value)
                }
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DayTimePicker;
